export function animateElement(
  type: 'up' | 'down',
  element: HTMLElement | null,
  distance = 0,
  duration = 500,
  easing = 'ease',
) {
  if (!element) return;

  const animations = {
    up: [
      {
        transform: 'translate(0, 100%',
      },
      {
        transform: 'translate(0, 0)',
      },
    ],
    down: [
      {
        transform: `translate(0, calc(0 - ${distance}px}))`,
      },
      {
        transform: 'translate(0, 100%)',
      },
    ],
  };

  return element.animate(animations[type], {duration, easing});
}
